import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Accordion, Button, Checkbox, Dropdown, Form, Grid, Icon, Label, Loader } from "semantic-ui-react";
import { DialogService } from "../../services/dialog-service";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { Project } from "../../stores/models/project";
import { ProjectMember } from "../../stores/models/project-member";
import { User } from "../../stores/models/user";
import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";
import { PermissionEditor } from "./permission-editor";
import { Agent } from "../../services/agent";
import { App } from "../../stores/models/app";

declare var toastr: any;

interface IProjectMemberEditorProps {
	projectStore?: ProjectStore;
	appStore?: AppStore;
	userStore?: UserStore;
	project: Project;
	member: ProjectMember;
	onRemoveMember(member: ProjectMember): void;
}

interface IProjectMemberEditorState {
	projectAccessDropdownOptions?: any;
	contactDropdownOptions?: any;
	active?: boolean;
}

@inject("projectStore", "appStore", "userStore") @observer
export class ProjectMemberEditor extends React.Component<IProjectMemberEditorProps, IProjectMemberEditorState>{
	selectedUsers: number[];

	constructor(props, state) {
		super(props, state);

		this.handleRemoveUser = this.handleRemoveUser.bind(this);
		this.handleProjectSelectChange = this.handleProjectSelectChange.bind(this);
		this.handleContactSelectChange = this.handleContactSelectChange.bind(this);
		this.handleMemberChange = this.handleMemberChange.bind(this);

		this.state = { "contactDropdownOptions": [], "projectAccessDropdownOptions": [], "active": true };
	}

	componentDidMount() {
		this.load(this.props);
	}

	componentWillReceiveProps(nextProps: IProjectMemberEditorProps) {
		this.load(nextProps);
	}

	load(props: IProjectMemberEditorProps) {
		if (props.member) {
			props.member.loadUser();
		}
		let contactOptions = [];
		props.userStore.contactTypes.forEach(type => {
			contactOptions.push({ "key": type.value, "text": type.name, "value": type.value });
		});

		let projectAccessDropdownOptions = [];
		props.projectStore.accessTypes.forEach(type => {
			projectAccessDropdownOptions.push({ "key": type.value, "text": type.name, "value": type.value });
		});

		if (props.member) {
			props.member.loadUser();
		}
		this.setState({ "contactDropdownOptions": contactOptions, "projectAccessDropdownOptions": projectAccessDropdownOptions });
	}


	handleRemoveUser() {
		if (this.props.onRemoveMember) {
			this.props.onRemoveMember(this.props.member);
			toastr.success("Change Saved");
		}
	}

	async handleProjectSelectChange(e, props) {
		this.props.member.updateProperty("access", props.value);
		await this.props.member.save();
		toastr.success("Change Saved");
	}

	async handleContactSelectChange(e, props) {
		this.props.member.updateProperty("contactType", props.value);
		await this.props.member.save();
		toastr.success("Change Saved");
	}

	async handleMemberChange() {

	}

	render() {
		if (_.isNil(this.props.member)) {
			return null;
		}
		else if (_.isNil(this.props.member.user)) {
			return null;
		}

		return (
			<Accordion styled fluid className="member-accordion">
				<Accordion.Title className="jibunu-lightgreen-background" active={this.state.active} onClick={() => this.setState({ "active": !this.state.active })}>
					<Icon name="dropdown" />
					{this.props.member.user.username}
				</Accordion.Title>
				<Accordion.Content active={this.state.active}>
					<Form>
						<Form.Group>
							<Form.Select compact label="Project Access" defaultValue={this.props.member.access} placeholder="Select Access" width={3} options={this.state.projectAccessDropdownOptions} onChange={this.handleProjectSelectChange} />
							<Form.Select compact label="Contact" defaultValue={this.props.member.contactType} placeholder="Select Contact" width={3} options={this.state.contactDropdownOptions} onChange={this.handleContactSelectChange} />
							<Form.Button label="Remove" icon="trash" color="red" width={3} onClick={this.handleRemoveUser}></Form.Button>
						</Form.Group>
					</Form>
					<PermissionEditor member={this.props.member} project={this.props.project} onMemberChanged={this.handleMemberChange}/>
				</Accordion.Content>
			</Accordion>
		);

	}
}



// WEBPACK FOOTER //
// ./src/views/projects/project-member-editor.tsx